export function cameraSystemForProperty(systems: any[], propertyId: unknown): any | undefined {
  const wanted = String(propertyId ?? '');
  if (!wanted) return undefined;
  return (systems || []).find((system: any) =>
    (system?.entity_type === 'property' && String(system?.entity_id) === wanted)
    || (Array.isArray(system?.property_ids)
      && system.property_ids.some((id: unknown) => String(id) === wanted))
    || (Array.isArray(system?.linked_property_ids)
      && system.linked_property_ids.some((id: unknown) => String(id) === wanted))
  );
}

export type StreamCameraProvider = 'turing' | 'unifi_protect';

export function cameraStreamRequest(provider: StreamCameraProvider, systemId: string, cameraId: string) {
  const route = provider === 'unifi_protect' ? 'unifi-protect' : 'turing';
  return {
    systemsPath: `/integrations/${route}/systems`,
    streamPath: `/integrations/${route}/systems/${encodeURIComponent(systemId)}/stream-url`,
    body: provider === 'unifi_protect'
      ? { camera_id: cameraId, quality: 'low' }
      : { camera_id: cameraId, resolution: 'sub' },
  };
}
